import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { formatViews } from "@/utils/movie";

interface MovieCardProps {
  movie: Movie;
  showSummary?: boolean;
}

export default function MovieCard({ movie, showSummary = true }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer"
      title={`${movie.title} - 熊猫影院`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 封面`}
          title={`${movie.title} 熊猫影院 在线观看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2">
          <span className="rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur-sm">
            {movie.typeLabel}
          </span>
          <span className="flex items-center gap-1 rounded-md bg-accent-500/90 px-2 py-0.5 text-[11px] font-bold text-foreground-950">
            <i className="ri-star-fill text-[10px]"></i>
            {movie.rating.toFixed(1)}
          </span>
        </div>
        {showSummary && (
          <div className="absolute inset-0 flex items-end bg-gradient-to-t from-foreground-950/95 via-foreground-950/40 to-transparent p-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <p className="line-clamp-4 text-xs leading-relaxed text-background-100">
              {movie.summary}
            </p>
          </div>
        )}
      </div>
      <div className="mt-2.5">
        <h3 className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
          <span className="truncate">{movie.genres.slice(0, 2).join(" · ")}</span>
        </div>
        <div className="mt-1 flex items-center gap-1 text-xs text-foreground-400">
          <i className="ri-play-circle-line text-[13px]"></i>
          <span>{formatViews(movie.views)}次播放</span>
        </div>
      </div>
    </Link>
  );
}